import { TableHeaderStyled } from "./TableHeader.styled";

const TableHeader = ({ children }) => (
  <TableHeaderStyled>{children}</TableHeaderStyled>
);

export default TableHeader;
